import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
})
export class ForgotPasswordComponent {
  constructor(private fb: FormBuilder) {}

  forgotPasswordForm = this.fb.group({
    email: ['', [Validators.required, Validators.email]],
  });

  onSubmit() {
    if (this.forgotPasswordForm.invalid) {
      this.forgotPasswordForm.markAllAsTouched();
      return;
    }

    const email = this.forgotPasswordForm.value.email;
    console.log('Solicitar recuperação para:', email);

    // TODO: chamar API de recuperar senha
  }

  hasError(controlName: string, error: string): boolean {
    const control = this.forgotPasswordForm.get(controlName);
    return !!control && control.touched && control.hasError(error);
  }
}
